export const transitions = {
	default: '0.2s ease-out',
};
